import {useMemo} from 'react';
import {useGetCuratedSetMutation} from '~/QuickEcards/api/ecard';
import {useAppSelector} from '~/QuickEcards/store';
import {selectTemplateName} from '~/QuickEcards/store/reducers/ecard';

export const useCuratedSets = () => {
  const [getCuratedSets, {data: curatedSets}] = useGetCuratedSetMutation({
    fixedCacheKey: 'curated-sets',
  });
  const templateId = useAppSelector(selectTemplateName);

  const curatedSet = useMemo(
    () => curatedSets?.find((template) => template.id === templateId),
    [curatedSets, templateId]
  );

  return {curatedSet, getCuratedSets};
};
